import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import Grid, { GridColumn } from '@telia-front/grid';
import { useTheme } from '@telia-front/theme-provider';
const ServiceCards = (props) => {
    const [outerWidth, setOuterWidth] = React.useState();
    const [showFillerItem, setShowFillerItem] = React.useState();
    const { className, children } = props;
    const { media } = useTheme();
    const isScreenSmallerThanSm = useMediaQuery({
        maxWidth: media.width.xs.max,
    });
    const isScreenSmallerThanXl = useMediaQuery({
        maxWidth: media.width.lg.max,
    });
    const serviceCardsRef = React.createRef();
    const serviceCardsOuterRef = React.createRef();
    const BEM = () => {
        const classArray = ['service-cards'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const updateDimensions = () => {
        var _a;
        const serviceCardsElement = serviceCardsRef.current;
        const serviceCardsOuterElement = serviceCardsOuterRef.current;
        const container = serviceCardsOuterElement === null || serviceCardsOuterElement === void 0 ? void 0 : serviceCardsOuterElement.parentElement;
        const containerWidth = container === null || container === void 0 ? void 0 : container.clientWidth;
        const containerComputedStyle = container && getComputedStyle(container);
        const containerWithoutPadding = containerWidth &&
            containerComputedStyle &&
            containerWidth - parseFloat(containerComputedStyle.paddingLeft) - parseFloat(containerComputedStyle.paddingRight);
        const cardItemWidth = ((_a = serviceCardsElement === null || serviceCardsElement === void 0 ? void 0 : serviceCardsElement.firstElementChild) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 152;
        const totalCardItemsWidth = cardItemWidth && cardItemWidth * children.length;
        const firstRowCardItemsWidth = cardItemWidth && cardItemWidth * Math.ceil(children.length / 2);
        if (containerWidth && totalCardItemsWidth && totalCardItemsWidth < containerWidth) {
            // Items are in one row
            setOuterWidth(totalCardItemsWidth);
            setShowFillerItem(false);
            /* istanbul ignore next */
            if (isScreenSmallerThanXl && children.length > 4) {
                setOuterWidth(firstRowCardItemsWidth && firstRowCardItemsWidth + cardItemWidth - 1);
                setShowFillerItem(children.length % 2 === 1);
            }
        }
        else if (containerWithoutPadding && firstRowCardItemsWidth && firstRowCardItemsWidth < containerWithoutPadding) {
            // Items are in two rows
            setOuterWidth(firstRowCardItemsWidth + cardItemWidth - 1);
            setShowFillerItem(children.length % 2 === 1);
            if (isScreenSmallerThanSm && children.length > 4) {
                setOuterWidth(cardItemWidth && cardItemWidth * 3 - 1);
            }
        }
        else {
            // Items are in pairs
            setOuterWidth(cardItemWidth && cardItemWidth * 3 - 1);
            setShowFillerItem(children.length % 2 === 1);
        }
    };
    React.useEffect(() => {
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    });
    const renderChildren = () => {
        return React.Children.map(children, (item, index) => {
            return (React.createElement(GridColumn, { key: index, width: ['xs'], className: "service-cards__item-col" }, item));
        });
    };
    const renderFillerColumn = () => {
        const fillerBEM = () => {
            const classArray = ['service-cards__item-col-filler'];
            if (showFillerItem) {
                classArray.push('service-cards__item-col-filler--show');
            }
            return classArray.join(' ');
        };
        return React.createElement(GridColumn, { width: ['xs'], className: fillerBEM(), "aria-hidden": true });
    };
    return (React.createElement(Grid, { className: "service-cards__outer", align: ['center-xs'], gridRef: serviceCardsOuterRef },
        React.createElement(GridColumn, { width: ['xs'] },
            React.createElement(Grid, { equalHeight: true, element: "ul", className: BEM(), align: ['between-xs'], gridRef: serviceCardsRef, style: { maxWidth: outerWidth } },
                renderChildren(),
                renderFillerColumn()))));
};
export { ServiceCards as default };
